export default __webpack_public_path__ + "static/media/Earnings-Grey.0a0bb419.svg";